<div class="agpr-accessible-code-mirror">
    <div
        *ngIf="textContent"
        aria-live="assertive"
        class="u-srOnly"
    >
        {{lineChanged ? 'Line ' + (currentLine + 1) + ': ' : ''}}{{textContent}}{{isSelection ? ' selected' : ''}}
    </div>
    <ngx-codemirror
        #codeEditor
        [class]="codeMirrorStyleClass"
        [ngModel]="value"
        (ngModelChange)="htmlChange.emit($event)"
        [options]="config"
        (cursorActivity)="debouncedCursorMoved()"
    ></ngx-codemirror>
</div>
